import gql from 'graphql-tag';

export const VLPCourseMaterialsQuery = gql`
  query VLPCourseMaterialsQuery($courseId: String!) {
    OnDemandLearnerMaterialsV1Resource {
      courses(courseIds: [$courseId]) {
        elements {
          id
          learnerMaterialItems(limit: 1000) {
            lectures: elements {
              id: itemId
              name
              lessonId
              timeCommitment: totalWorkDuration
              contentSummary {
                __typename
              }
              slug
            }
          }
          learnerMaterialLessons(limit: 250) {
            elements {
              id: lessonId
              moduleId
              itemIds
              name
            }
          }
          learnerMaterialModules(limit: 250) {
            elements {
              id: moduleId
              name
              description
              lessonIds
            }
          }
        }
      }
    }
  }
`;
